/* Nur Breitenanpassung der neuen GN-Module. Kein Quiz, keine Produktlogik.
   Inhalte sind serverseitiges HTML und bleiben ohne JavaScript lesbar. */
(() => {
const TAG = 'gnb-module';
if (!customElements.get(TAG)) {
  let probe;
  const measureLength = (value, fallback) => {
    if (!value || !value.trim()) return fallback;
    if (!probe || !probe.isConnected) {
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed;left:0;top:0;height:0;min-width:0;max-width:none;visibility:hidden;pointer-events:none;contain:strict;box-sizing:border-box;padding:0;border:0;';
      document.body.append(probe);
    }
    probe.style.width = '0px';
    probe.style.width = value;
    return probe.getBoundingClientRect().width || fallback;
  };
  class GNModule extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.refresh = this.refresh.bind(this);
      this.shell = this.querySelector(':scope > .gnb-shell');
      if (!this.shell) return;
      this.region = this.closest('.shopify-section') || document.querySelector('main') || document.documentElement;
      this.lastWidth = -1;
      this.observer = new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width;
        if (Math.abs((width || 0) - this.lastWidth) > .1) {this.lastWidth = width; this.queue();}
      });
      this.observer.observe(this.parentElement || this);
      this.onResize = () => this.queue();
      window.addEventListener('resize', this.onResize, {passive:true});
      this.bodyObserver = new MutationObserver(() => this.queue());
      this.bodyObserver.observe(document.body, {attributes:true, attributeFilter:['class','style']});
      this.querySelector('link[rel="stylesheet"]')?.addEventListener('load',this.onResize,{once:true});
      document.fonts?.ready.then(() => {if (this.isConnected) this.queue();});
      this.refresh();
    }
    queue() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {this.frame = 0; if(this.isConnected) this.refresh();});
    }
    refresh() {
      if (!this.shell) return;
      const slot = this.getBoundingClientRect();
      const region = this.region.getBoundingClientRect();
      const viewport = document.documentElement.clientWidth;
      const left = Math.max(0, region.left);
      const right = Math.min(viewport, region.right);
      const available = Math.max(0, right-left);
      const bodyStyle = getComputedStyle(document.body);
      const shellStyle = getComputedStyle(this.shell);
      const mode = this.dataset.width;
      let width = slot.width, x = slot.left;
      if (mode === 'page') {
        // Body statt schmaler .page-width-content-Section.
        const maxWidth = measureLength(bodyStyle.getPropertyValue('--page-content-width'), 1440);
        const gutter = measureLength(bodyStyle.getPropertyValue('--page-margin'), viewport < 750 ? 16 : 40);
        width = Math.min(maxWidth, Math.max(0,available-gutter*2));
        x = left + (available-width)/2;
      } else if (mode === 'full') {
        const variable = viewport < 750 ? '--gnb-edge-m' : '--gnb-edge';
        const gutter = Math.max(0,parseFloat(shellStyle.getPropertyValue(variable)) || 0);
        width = Math.max(0,available-gutter*2); x = left+gutter;
      }
      this.style.setProperty('--gnb-measured-width', `${width.toFixed(3)}px`);
      this.style.setProperty('--gnb-measured-offset', `${(x-slot.left).toFixed(3)}px`);
    }
    disconnectedCallback() {
      if (this.startFrame) cancelAnimationFrame(this.startFrame);
      this.observer?.disconnect(); this.bodyObserver?.disconnect();
      window.removeEventListener('resize',this.onResize);
      if(this.frame) cancelAnimationFrame(this.frame);
    }
  }
  customElements.define(TAG, GNModule);
}
})();
